
document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".how-it-works .multicolumn-list__item");
    let current = 0;

    function activateNext() {
        items.forEach(item => item.classList.remove("is-active"));
        items[current].classList.add("is-active");

        current = (current + 1) % items.length;
    }

    activateNext();
    setInterval(activateNext, 3000);
});



function wrapQuantityAndButtons() {
  const quantityDiv = document.querySelector(".product-form__input");
  const buyButtonsDiv = document.querySelector(".buy-buttons-cst");

  // safety checks
  if (!quantityDiv || !buyButtonsDiv) return;

  // prevent duplicate wrapper
  if (quantityDiv.closest(".quantity-buy-wrapper")) return;

  // create wrapper
  const wrapper = document.createElement("div");
  wrapper.className = "quantity-buy-wrapper";

  // insert wrapper before quantity
  quantityDiv.parentNode.insertBefore(wrapper, quantityDiv);

  // move elements inside wrapper
  wrapper.appendChild(quantityDiv);
  wrapper.appendChild(buyButtonsDiv);
}

/* initial load */
document.addEventListener("DOMContentLoaded", function () {
  wrapQuantityAndButtons();
});

/* Shopify variant re-render fix */
document.addEventListener("variant:change", function () {
  setTimeout(() => {
    wrapQuantityAndButtons();
  }, 100);
});
